import React, { useEffect, useState } from 'react'
import SmsTab from './SMSTab'
import { useParams } from 'react-router-dom';
import { useGetLogspaginationQuery } from 'src/services/ContactServices';

const SMSTabWrapper = () => {  
    const { contactId } = useParams();
    const [smsData, setSmsData] = useState<any>();
  
    const { data, isLoading, isFetching } = useGetLogspaginationQuery({
      limit: 10,
      searchValue: "",
      params: ["description"],
      page: 0,
      filterBy: [
        {
          fieldName: "contactId",
          value: [contactId || ""],
        },
        {
          fieldName: "logType",
          value: ["SMS"],
        },
      ],
      dateFilter: {},
      orderBy: "createdAt",
      orderByValue: -1,
      isPaginationRequired: false,
    });
  
    useEffect(() => {
      if (!isLoading && !isFetching) {
        setSmsData(data?.data);
      }
    }, [data, isLoading, isFetching]);
  return (
    <SmsTab isLoading={isLoading || isFetching} smsData={smsData}/>
  )
}

export default SMSTabWrapper